(function () {
    "use strict";

    angular.module("services")
        .service("SocialService", SocialService);

    SocialService.$inject = ["$http", "API_BASE", "$q"];

    function SocialService($http, API_BASE, $q) {
        var service = this;

        service.getAllSubscriptions = getAllSubscriptions;

        function getAllSubscriptions(query) {
            return $http.get(API_BASE + "/social/subscriptions", { params: query });
        }
    }
})();
